import { IFirebaseConfig } from 'app/interface/IConfig'

export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
}
export interface ICountries {
  [key: string]: {
    center: {
      lat: number
      lng: number
    }
    zoom: number
  }
}
declare global {
  interface Window {
    google: any
    Moengage: any
    registration: any
    FIREBASE_CONFIG: IFirebaseConfig
  }
}
export const defaultCountries: ICountries = {
  id: {
    center: {
      lat: -6.208581139178905,
      lng: 106.84084550773397,
    },
    zoom: 6,
  },
  ph: {
    center: {
      lat: 11.7501514,
      lng: 119.4477298,
    },
    zoom: 6,
  },
  th: {
    center: {
      lat: 13.7251088,
      lng: 100.3529072,
    },
    zoom: 6,
  },
  vn: {
    center: {
      lat: 15.6833988,
      lng: 108.5819973,
    },
    zoom: 6,
  },
}
export const MAP = {
  API_KEY: import.meta.env.VITE_GOOGLE_API_KEY,
  GOOGLE_AUTOCOMPLETE_URL: import.meta.env.VITE_GOOGLE_AUTOCOMPLETE_URL,
  GOOGLE_DIRECTION_URL: import.meta.env.VITE_GOOGLE_DIRECTION_URL,
}

export const SETTING_SLIDER = {
  infinite: false,
  speed: 500,
  slidesToScroll: 1,
  variableWidth: true,
  swipeToSlide: true,
}

export const CUSTOMER_SETTING = {
  VIEW_DRIVER_PROFILE: 'ViewDriverProfile',
  TERM_CONDITION_URL: 'TermConditionsURL',
  LEARN_MORE: 'LearnMore',
  EXPIRE_TIME_HOLD_BOOKING: 'ExpireTimeHoldBooking',
  EXPIRE_TIME: 'ExpireTime',
  PRIVATE_POLICY_URL: 'PrivatePolicyURL',
  MAX_UNIT_QUANTITY: 'MaxUnitQuantity',
  LOADS_DASHBOARD: 'LoadsDashboard',
  POPUP_AUTO_HIDE_COUNT_DOWN: 'PopupAutoHideCountDown',
  LEARN_HOW_IT_WORDS: 'LearnHowItWorks',
  MIN_TARGET_PRICE: 'MinTargetPrice',
  MAX_TARGET_PRICE: 'MaxTargetPrice',
  TRANSPORT_TYPE_DEFAUL: 'TransportTypeDefault',
  MIN_UNIT_QUANTITY: 'MinUnitQuantity',
  BUFFER_TIME: 'BufferTime',
  LTL_DRIVER_LINK: 'LTLDriverLink',
  FTL_LINK: 'FTLLink',
  CANCELLATION_POLICY_URL: 'CancellationPolicyURL',
  ADDITIONAL_SERVICE_FOR_ADVERTISEMENT: 'AdditionalServiceForAdvertisement',
  SERVICE_URL: 'ServiceURL',
  USER_AGREEMENT_URL: 'UserAgreementURL',
  DEFAULT_AVATAR_URL: 'DefaultAvatarURL',
  FULL_VEHICLE_DASHBOARD: 'FullVehicleDashboard',
  MIN_WEIGHT_OF_ITEM: 'MinWeightofItem',
}

export const COUNTRY_NAMES = {
  ID: 'Indonesia',
  PH: 'Philippines',
  VN: 'Vietnam',
  TH: 'Thailand',
}

export const PARAM_URL = {
  TAB: 'tab',
  SCROLL_TO: 'scroll_to',
}

export const TAB_ENUM = {
  BOOKING: 'booking',
  QUOTES: 'quotes',
  PROGRESS: 'progress',
  COMMUNICATION: 'communication',
  PAYMENT: 'payment',
}

export const TAB_ENUMS_MANAGER = {
  PENDING: 'Pending',
  DRAFT: 'Draft',
  PAST: 'Past',
}

export const BOOKING_SCROLL_TO = {
  LOCATIONS: 'locations',
  SUMMARY: 'summary',
  PHOTOS: 'photos',
  ITEMS: 'items',
}

export const SUPPORTED_MEDIA_TYPES = ['.jpeg', '.jpg', '.png', '.pdf', '.doc', '.docx']
export const ANDROID = 'Android'
export const MAX_FILE_SIZE = 8 * 1024 * 1024 // 8MB
export const MIN_OS_VERSION_SUPPORT_CHAT = 19

export const ROUTE = {
  BOOKING: 'booking',
  LISTING_CREATED: 'listing-created',
}

export const EVENT_FB = {
  CHILD_ADDED: 'child_added',
  CHILD_REMOVED: 'child_removed',
}

export const CHANNEL_FIREBASE = {
  AVAILABLE_BOOKINGS: 'available_bookings',
  CS_FINDING_DRIVER_BOOKINGS: 'cs_finding_driver_bookings',
}

export const REASON_TYPE = {
  DeleteShipment: 0,
  RejectQuote: 1,
  CancelShipment: 2,
  UnlistShipment: 3,
  CancelShipmentAfterAcceptance: 4,
  CSCancel: 5,
}

export const CLEAR_LOCAL_STORAGE = '#CLEAR_LOCAL_STORAGE'

export const STEP_NUMBER = {
  STEP_ONE: 1,
  STEP_TWO: 2,
  STEP_THREE: 3,
  STEP_FOUR: 4,
}
export const STEP = 'step'

export const COUNTRY_CODE_SUPPORT = {
  TH: 'th',
  VN: 'vn',
  PH: 'ph',
  ID: 'id',
}
export const DEFAULT_VALUE = {
  COUNT_DOWN: 10,
  DEFAULT_WIDTH_DPI: 1024,
  DEFAULT_HEIGHT_DPI: 1024,
  DEFAULT_SIZE_OF_KB: 1024,
}

export enum DYNAMIC_TEXT_OPTION {
  GOODS_INSURANCE = 'goods_insurance',
  TOLLS_AND_PARKING = 'tolls_and_parking',
  LCL_DISCLAIMER = 'lcl_disclaimer',
  GOODS_DESCRIPTION = 'goods_description',
}

export enum LCL_SETTING_OPTION {
  BUFF_DEPO_CLOSING_TIME = 'buff_depo_closing_time',
  DAY_BUFFER_FINAL_STOP = 'day_buffer_final_stop',
  TRANSACTION_FEE_SPIL = 'transaction_fee_spil',
  ICON_TRUCKING_VENDOR = 'icon_trucking_vendor',
  DAY_BUFFER_PAYMENT_DEADLINE = 'day_buffer_payment_deadline',
  WHO_PAYMENT_TRANSACTION_FEE = 'who_payment_transaction_fee',
  INSURANCE_POLICY_URL = 'insurance_policy_url',
  ENABLE_ELECTRONIC_POD_FEATURE = 'enable_electronic_pod_feature',
  DEFAULT_CHECK_ELECTRONIC_POD_BP = 'default_check_electronic_pod_bp',
  DEFAULT_CHECK_ELECTRONIC_POD_NONBP = 'default_check_electronic_pod_nonbp',
  DEFAULT_COMMODITY = 'default_commodity',
  DEFAULT_PACKAGE = 'default_package_unit',
}

export const SECTION_TYPE_POPUP = {
  STEP_2_TO_3: 'step_2_to_3',
}
